@if (incomeTaxEntity$ | async) {
  <form [formGroup]="formGroup">
    <div formArrayName="extraUitgavenKledingEnBeddengoed">
      @for (item of extraUitgavenKledingEnBeddengoed.controls; track item; let i = $index) {
        <div [formGroupName]="i" class="row" style="--bs-gutter-x: 0.5rem;">
          <snelstart-ui-select-form-control [label]="i === 0 ? 'Duur van de ziekte' : ''"
                                            [options]="itemsDuurZiekte"
                                            [required]=true
                                            class="col-auto custom-input-250"
                                            formControlName="duurZiekteMinimaalJaar"
                                            id="duurZiekteMinimaalJaar-{{i}}"
          >
          </snelstart-ui-select-form-control>
          <div [formGroup]="getPeriodeFormGroup(i)" class="row col-auto" style="--bs-gutter-x: 0.5rem;">
            <snelstart-ui-date-form-control [label]="i === 0 ? 'Begindatum' : ''"
                                            [placeholder]="'dd-mm-' + (incomeTaxEntity$ | async)?.year"
                                            [required]=true
                                            class="col-auto custom-input-150"
                                            formControlName="begindatum"
                                            id="begindatum-{{i}}">
            </snelstart-ui-date-form-control>
            <snelstart-ui-date-form-control [label]="i === 0 ? 'Einddatum' : ''"
                                            [placeholder]="'dd-mm-' + (incomeTaxEntity$ | async)?.year"
                                            [required]=true
                                            class="col-auto custom-input-150"
                                            formControlName="einddatum"
                                            id="einddatum-{{i}}">
            </snelstart-ui-date-form-control>
          </div>
          <div class="col-auto d-flex align-items-center" style="--bs-gutter-x: 0.5rem;">
            <snelstart-ui-select-form-control [label]="i === 0 ? 'Hoogte van de uitgaven' : ''"
                                              [options]="itemsJaNee"
                                              class="custom-input-250"
                                              formControlName="extraUitgavenKledingBeddengoedHogerDanMax"
                                              id="extraUitgavenKledingBeddengoedHogerDanMax-{{i}}"
            >
            </snelstart-ui-select-form-control>
          </div>
          <snelstart-ui-button (click)="verwijderRij(i)"
                               [class]="i === 0 ? 'firstrowbutton col-auto ' : 'col-auto '"
                               icon="trash"
                               iconType="light"
                               id="buttonDeleteKosten"
                               size="medium"
                               type="secondary"
          >
          </snelstart-ui-button>
        </div>
      }
    </div>
  </form>
  <snelstart-ui-button (click)="addRij()" class="snelstart-ui-button pb-3" icon="plus"
                       type="link">Uitgaven kleding en beddengoed
  </snelstart-ui-button>

}
